<template>
  <div class="statis-student-overview">
    <div class="title">概览</div>
    <Button type="primary" :to="{name:'StatisticsStudent'}">学员列表</Button>
    <div class="overview-total">
      <div class="overview-box">
          <div>累计用户数</div>
          <div class="tips">上线至今</div>
          <div class="number">{{total.total}}人</div>
      </div>
      <div class="overview-box">
        <div>新增用户数</div>
        <div class="tips">{{total.week_total.start}}~{{total.week_total.end}} | 最近一周</div>
        <div class="number">{{total.week_total.data}}人</div>
      </div>
      <div class="overview-box">
        <div>今日新增用户数</div>
        <div class="tips">{{total.today_total.today}}</div>
        <div class="number">{{total.today_total.data}}人</div>
      </div>
    </div>
    <div class="overview-line">
      <Form :model="searchCondition" :label-width="70" inline>
        <FormItem label="日期范围">
          <DatePicker
            ref="formDate"
            type="daterange"
            placeholder="选择日期范围"
            @on-change="onDateChange"
            style="width:200px;"
            :editable="false"
            clearable
          ></DatePicker>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearch">搜索</Button>
            <Button icon="md-undo" @click="onReset">重置</Button>
          </div>
        </FormItem>
      </Form>

      <div class="new-increase">累计用户数：{{searchTotal}}人</div>

      <div class="container">
        <chart ref="chart1" :options="orgOptions" :auto-resize="true"></chart>
      </div>
    </div>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";
import 'echarts/lib/chart/line'
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  name: "StudentOverview",
  data() {
    return {
      orgOptions: {},
      searchCondition: {
        start: '',
        end: ''
      },
      total: {
        total: 0,
        week_total: {
          start: '',
          end:'',
          data: 0
        },
        today_total: {
          today: '',
          data: 0
        }
      },
      searchTotal: 0
    };
  },
  created() {
    this.requestTotal();
    this.requsetLine()
  },
  methods: {
    onSearch() {
      this.requsetLine();
    },
    onReset() {
      this.searchCondition.start = '';
      this.searchCondition.end = '';
      this.requsetLine();
    },
    onDateChange(date) {
      this.searchCondition.start = parseInt(new Date(date[0]).getTime() / 1000);
      this.searchCondition.end = parseInt(new Date(date[1]).getTime() / 1000);
    },
    requestTotal()
    {
      this.$http.post('/api/user/statics/total').then(res=>{
        this.total = res
      })
    },
    requsetLine() {
      let _this = this;
      this.$http.post('/api/user/statics/line',this.searchCondition).then(res=>{
        this.orgOptions = {
          tooltip: {
              trigger: 'axis',
              show: true
          },
          xAxis: {
              type: 'category',
              data: res.line.date
          },
          yAxis: {
              type: 'value'
          },
          series: [{
              name:'新增人数',
              data: res.line.count,
              type: 'line',
              stack: '总量',
              width: 500
          }],
          legend: {
              data:['新增人数']
          },
          width:800,
          height: 250,
        };
        _this.searchTotal = res.count
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.overview-total{
  width: 80%;
  display: flex;
  margin-bottom: 30px;
  .overview-box{
    width: 250px;
    border: 1px solid #989595;
    line-height: 33px;
    text-align: center;
    padding: 30px 0;
    flex: 1;
    margin: 5px 20px;
  }
  .tips{
    color: #b3b2b2;
  }
  .number{
    color: #e81616;
    font-size: 20px;
  }
}
.overview-line{
  .new-increase{
    color: #e81616;
  }
}
.echarts{
  width: 1000px;
  height: 400px;
}
</style>
